// Common background configurations
const commonBackgroundConfig = {
  backgroundSize: "100% auto, 100% auto",
  backgroundRepeat: "no-repeat, repeat",
  backgroundPosition: "bottom center, top center",
};

// Helper function to create background styles
const createBackgroundStyle = (
  bottomImage,
  patternImage = backgroundImages.pattern
) => ({
  backgroundImage: `url(${bottomImage}), url(${patternImage})`,
  ...commonBackgroundConfig,
});

const backgroundImages = {
  moon: "/yofukashi/bottom_moon.png",
  townShort: "/yofukashi/bottom_town_short.png",
  townLong: "/yofukashi/bottom_town_long.png",
  present: "/yofukashi/bottom_present.png",
  pattern: "/yofukashi/pattern.jpg",
};

const backgroundStyles = {
  Tickets: createBackgroundStyle(backgroundImages.townShort),
  MyPage: createBackgroundStyle(backgroundImages.moon),
  Quests: createBackgroundStyle(backgroundImages.townLong),
  HowToUse: createBackgroundStyle(backgroundImages.moon),
  News: createBackgroundStyle(backgroundImages.moon),
  EmailSettings: createBackgroundStyle(backgroundImages.moon),
  ConfirmPayPay: createBackgroundStyle(backgroundImages.moon),
  CheckPayPayStatus: createBackgroundStyle(backgroundImages.moon),
  PayPayPolling: createBackgroundStyle(backgroundImages.moon),
  PayPayConfirm: createBackgroundStyle(backgroundImages.moon),
  // Cover the entire reservation page, including its footer, on tall screens.
  Birthday: {
    backgroundImage: `url(${backgroundImages.present})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundColor: "#030807",
  },
};

export default backgroundStyles;
